var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-page',{attrs:{"padding":""}},[_c('div',{staticClass:"q-mb-sm filter-bar"},[_c('FilterBar',{on:{"refreshPage":_vm.refreshPage}})],1),_c('div',{key:_vm.lastTimeStamp,staticClass:"row q-mb-xs q-col-gutter-md"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('BoxStoreRank')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }